import Vue from 'vue';
//GoogleMaps
import * as VueGoogleMaps from 'vue2-google-maps';
import { generateColor } from '@/functions/color/color.js';
import { lightenDarkenColor, isNull } from '@/functions/Util.js';

// carregamento de informações para o sistema. São coisas como:
// Tema, Usuário, ModuloPDA, Empresas

export const getUsuario = async (_store, setAuthenticated = false) => {
    return await new Promise((resolve, reject) => {
        Vue.prototype.$axios
            .get('user/current.json')
            .then((response) => {
                let count = 0;
                for (let key in response.data.content.permissao) {
                    if (
                        key.startsWith('permite') &&
                        response.data.content.permissao[key] === true
                    ) {
                        count++;
                    }
                }

                if (count == 0) {
                    console.warn('Não há permissões de acesso para o usuário');
                    _store.dispatch('authenticated', { value: false });
                } else if (setAuthenticated) {
                    _store.dispatch('authenticated', { value: true });
                }

                let _user = response.data.content;

                _user.usuario.assusuariousuarioList = _user.usuario.assusuariousuarioList || [];

                Vue.use(VueGoogleMaps, {
                    load: {
                        key: _user.gmapsApiKey
                            ? Vue.CryptoJS.AES.decrypt(
                                  _user.gmapsApiKey,
                                  atob('UzBWMVMyMDA3UzBWMVMyMDE5UzBWMVMuIUAj')
                              ).toString(Vue.CryptoJS.enc.Utf8)
                            : '',
                        libraries: 'visualization',
                    },
                });
                _store.dispatch('user', { value: _user });

                resolve(_user);
            })
            .catch((error) => {
                _store.dispatch('authenticated', { value: false });
                console.info('Usuário não encontrado, faça login');
                if (process.env.NODE_ENV === 'development') {
                    console.info(error.data);
                }
                reject(error);
            });
    });
};

/**
 * Busca permissões de acesso do usuário logado.
 */
export const getUsuarioMenu = async (_store) => {
    let _idusuarioerp = _store.state.user.idusuarioerp;
    return await new Promise((resolve, reject) => {
        Vue.prototype.$axios
            .get(`config/access-profile/user/${_idusuarioerp}.json`)
            .then((response) => {
                if (response.status != 200) {
                    console.error(`Erro status ${response.status} ao carregar Menus.`);

                    _store.dispatch('app_moduloDisponivel', { value: false });
                    _store.dispatch('app_telaDisponivel', { value: false });

                    reject();
                } else {
                    console.log('Menus carregadas com sucesso');
                    _store.dispatch('app_moduloData', {
                        value: Object.assign(response.data.content),
                    });

                    let app_moduloList = Object.assign(response.data.content.app_moduloList);
                    // para montar um array con todas as telas
                    let app_telaList = [];

                    app_moduloList.forEach((app_modulo) => {
                        app_modulo.expanded = false;

                        let app_moduloList2 = app_modulo.app_moduloList;
                        if (isNull(app_moduloList2)) return;
                        app_moduloList2.forEach((app_modulo2) => {
                            let app_telaList2 = app_modulo2.app_telaList;
                            if (isNull(app_telaList2)) return;
                            app_telaList.push(...app_telaList2);
                        });
                    });
                    _store.dispatch('app_telaData', { value: app_telaList });

                    let app_moduloListTemp = app_moduloList.filter(f => f.visivel);

                    if (app_moduloListTemp && app_moduloListTemp.length > 0) {
                        $cookies.set('context', app_moduloListTemp[0].nome);
                        _store.dispatch('context', { value: app_moduloListTemp[0].nome });
                    }

                    resolve(response.data.content);
                }
            });
    });
};

/**
 * Tema da aplicação;
 * Carrega primeiro o tema, pois não só ele contém as informações das cores e logotipos,
 * mas também os endereços para redirecionar em caso de logout;
 * Em caso de falha, usa o padrão do objeto defaultTheme abaixo;
 * Não precisa do usuário logado para carregar, pois também é necessário na tela de login.
 */
export const getTheme = async (_store) => {
    let layoutId = $cookies.get('id_layout') ? $cookies.get('id_layout') : 0;

    return await new Promise((resolve, reject) => {
        Vue.prototype.$axios
            .get(`theme/${window.location.hostname}/${layoutId}.json`)
            .then((response) => {
                if (response.data.content != null) {
                    _store.dispatch('partnerSystemHasLayout', { value: response.data.content });
                    // redireciona caso esteja no domínio incorreto
                    let domain = `${response.data.content.fvw_subdomain_app}.${response.data.content.fvw_domain}`;
                    if (
                        process.env.VUE_APP_LOCALHOST_BLOCK == 'true' &&
                        domain != window.location.hostname
                    ) {
                        window.location.replace(process.env.VUE_APP_PROTOCOLO + domain);
                    }
                    console.log('Tema carregado com sucesso');
                } else {
                    console.log('Tema padrão carregado');
                }
                configColor(_store);
                resolve();
            })
            .catch((e) => {
                console.error('Erro ao carregar tema. Tema padrão carregado', e);
                configColor(_store);
                reject();
            });
    });
};

const configColor = (_store) => {
    let theme = _store.state.partnerSystemHasLayout;

    let regexColor = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i;

    if (regexColor.test(theme.primary_color) && regexColor.test(theme.secondary_color)) {
        localStorage.setItem(
            'paleta',
            JSON.stringify(
                generateColor(
                    theme.primary_color,
                    theme.secondary_color,
                    null,
                    theme.color_intensity ? theme.color_intensity : 0.9
                )
            )
        );
        localStorage.setItem(
            'color_intensity',
            theme.color_intensity ? theme.color_intensity : 0.9
        );
    }

    let root = document.documentElement;

    if (regexColor.test(theme.primary_color)) {
        let hover = lightenDarkenColor(theme.primary_color, 20);
        // console.log(`${theme.primary_color}`, `#${hover}`);

        root.style.setProperty('--primary-color-hover', `#${hover}`);
        root.style.setProperty('--primary-color', theme.primary_color);
    } else {
        console.warn(`Invalid primary_color: ${theme.primary_color}`);
    }

    if (regexColor.test(theme.secondary_color)) {
        let hover = lightenDarkenColor(theme.secondary_color, 20);
        // console.log(`${theme.secondary_color}`, `#${hover}`);

        root.style.setProperty('--secondary-color-hover', `#${hover}`);
        root.style.setProperty('--secondary-color', theme.secondary_color);
    } else {
        console.warn(`Invalid secondary_color: ${theme.secondary_color}`);
    }

    if (regexColor.test(theme.light_color)) {
        // console.log(`${theme.light_color}`);
        root.style.setProperty('--primary-bn-color', theme.light_color);
    } else {
        console.warn(`Invalid light_color: ${theme.light_color}`);
    }

    if (regexColor.test(theme.dark_color)) {
        // console.log(`${theme.dark_color}`);
        root.style.setProperty('--primary-color-click', theme.dark_color);
    } else {
        console.warn(`Invalid dark_color: ${theme.dark_color}`);
    }
};

export const getModuloPDA = async (_store) => {
    return await new Promise((resolve, reject) => {
        Vue.prototype.$axios
            .get('/modulopda.json')
            .then((response) => {
                if (response.status != 200) {
                    _store.dispatch('modulopdaDisponivel', { value: false });
                } else {
                    _store.dispatch('modulopdaData', { value: response.data.content });
                }
                resolve(response.data.content);
            })
            .catch((e) => {
                if (e.status == '403') {
                    console.error('Acesso negado');
                    _store.dispatch('authenticated', { value: false });
                } else {
                    console.error(e.body ? e.body.message : e);
                }

                _store.dispatch('modulopdaDisponivel', { value: false });
                reject();
            });
    });
};

export const getEmpresa = async (_store) => {
    return await new Promise((resolve, reject) => {
        Vue.prototype.$axios
            .get('vendas/empresaold.json?page=0&limit=1000')
            .then((response) => {
                if (response.status != 200) {
                    _store.dispatch('empresasDisponivel', { value: false });
                } else {
                    _store.dispatch('empresasData', { value: response.data.content });
                }
                resolve();
            })
            .catch((e) => {
                if (e.status == '403') {
                    console.error('Acesso negado');
                    _store.dispatch('authenticated', { value: false });
                } else {
                    console.error(e.body ? e.body.message : e);
                }
                _store.dispatch('empresasDisponivel', { value: false });
                reject();
            });
    });
};
